module.exports = __webpack_public_path__ + "img/keno_snails.accd10d6.png";